/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation updateSecurityGeneralMutation($settings: JSON) {
        systemSettings: updateSystemSettings(section: sso, settings: $settings)
    }
`;
